import { gql } from '@apollo/client';

export const CREATE_CAMPAIGN = gql(/* GraphQL */ `
  mutation CreateCampaign($input: CreateCampaignInput!) {
    createCampaign(input: $input) {
      campaignId
      merchantId
      name
      status
      createdBy
      createdAt
      updatedAt
      scheduled
      generatedAt
      metadata
      segments {
        include
        exclude
      }
      variants {
        variantId
        campaignId
        channel
        variantName
        splitWeight
        content
        metadata
        createdAt
        updatedAt
      }
    }
  }
`);

export const SET_STATUS_AS_SCHEDULED = gql(/* GraphQL */ `
  mutation SetStatusAsScheduled($campaignId: ID!) {
    setStatusAsScheduled(id: $campaignId) {
      campaignId
      merchantId
      name
      status
      createdBy
      createdAt
      updatedAt
      scheduled
      generatedAt
      metadata
      segments {
        include
        exclude
      }
      variants {
        variantId
        campaignId
        channel
        variantName
        splitWeight
        content
        metadata
        createdAt
        updatedAt
      }
    }
  }
`);

export const UPDATE_CAMPAIGN = gql(/* GraphQL */ `
  mutation UpdateCampaign($updateCampaignId: ID!, $input: UpdateCampaignInput!) {
    updateCampaign(id: $updateCampaignId, input: $input) {
      campaignId
      merchantId
      name
      status
      createdBy
      createdAt
      updatedAt
      scheduled
      generatedAt
      metadata
      segments {
        include
        exclude
        __typename
      }
      variants {
        variantId
        campaignId
        channel
        variantName
        splitWeight
        content
        metadata
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`);

export const DELETE_CAMPAIGN = gql(/* GraphQL */ `
  mutation DeleteCampaign($campaignId: ID!) {
    deleteCampaign(id: $campaignId) {
      campaignId
      name
      status
    }
  }
`);

export const SEND_CAMPAIGN_PREVIEW = gql(/* GraphQL */ `
  mutation SendCampaignPreview($input: SendCampaignPreviewInput!) {
    sendCampaignPreview(input: $input)
  }
`);
